import {
  days_of_the_week,
  hours_minutes,
  roundToNearestMinute,
} from "../../../consts/misc";
import { Event } from "../../../interfaces";
import {
  getCategory,
  getCurrentDay,
  getCurrentWeek,
  getDayIndex,
} from "../../../utils/getMethods";

const Table = (props: any) => {
  const { events, setEventSelected, eventToggler, setOnEdit } = props;

  const handleOnClick = (event: Event) => {
    setEventSelected(event);
    setOnEdit(true);
    eventToggler.toggle();
  };

  const dayColumns = getCurrentWeek(props.weekStart, props.weekEnd).map(
    (date, key) => {
      const index = getDayIndex(date.getDay());
      const currentDay = days_of_the_week[index!];
      const currentDate = date.getDate();
      return (
        <div key={key} className={`column`}>
          {hours_minutes().map((hourMinutes, key1) => {
            date.setHours(hourMinutes.hour);
            date.setMinutes(hourMinutes.minute);
            return (
              <div key={key1} className={"table-cell"}>
                {events.map((event: Event, key2: number) => {
                  const startingDay = getCurrentDay(event.starting_date).word;
                  const startingDate = event.starting_date.getDate();
                  const endingDay = getCurrentDay(event.ending_date).word;
                  const endingDate = event.ending_date.getDate();

                  const dateStartRounded = roundToNearestMinute(
                    event.starting_date,
                    10
                  );

                  const dateEndRounded = roundToNearestMinute(
                    event.ending_date,
                    10
                  );

                  const startingHour = dateStartRounded.getHours();
                  const startingMinutes = dateStartRounded.getMinutes();
                  const endingHour = dateEndRounded.getHours();
                  const endingMinutes = dateEndRounded.getMinutes();

                  const startCondition =
                    startingDate === currentDate &&
                    startingDay === currentDay &&
                    startingHour === hourMinutes.hour &&
                    startingMinutes === hourMinutes.minute;

                  const progressCondition =
                    dateStartRounded.getTime() < date.getTime() &&
                    date.getTime() < dateEndRounded.getTime();

                  const endingCondition =
                    endingDate === currentDate &&
                    endingDay === currentDay &&
                    hourMinutes.hour === endingHour &&
                    hourMinutes.minute === endingMinutes;

                  const category = getCategory(event.related_offer_category);

                  if (startCondition) {
                    return (
                      <div
                        key={key2}
                        className={"table-cell-filled start-cell"}
                        style={{
                          /* 
                          backgroundColor: category.bgColor, */
                          borderTopLeftRadius: "8px",
                          borderTopRightRadius: "8px",
                          borderTop: `8.5px solid ${category.bgColor}`,
                          cursor: "pointer",
                        }}
                        onClick={() => handleOnClick(event)}
                      >
                        <p
                          className="cell-event-name"
                          style={{ cursor: "pointer" }}
                        >
                          {event.related_offer_name}
                        </p>
                        <div
                          className="cell-category-box"
                          style={{
                            backgroundColor: category.bgColor,
                            cursor: "pointer",
                          }}
                        >
                          <p
                            className="cell-category-text"
                            style={{
                              color: category.textColor,
                              cursor: "pointer",
                            }}
                          >
                            {event.related_offer_category}
                          </p>
                        </div>
                      </div>
                    );
                  } else if (progressCondition) {
                    return (
                      <div
                        key={key2}
                        className={"table-cell-filled"}
                        style={{
                          backgroundColor: category.bgColor,
                          cursor: "pointer",
                        }}
                        onClick={() => handleOnClick(event)}
                      ></div>
                    );
                  } else if (endingCondition) {
                    return (
                      <div
                        key={key2}
                        className={"table-cell-filled end-cell"}
                        style={{
                          /* backgroundColor: category.bgColor,  */
                          borderBottomLeftRadius: "8px",
                          borderBottomRightRadius: "8px",
                          borderBottom: `8px solid ${category.bgColor}`,
                          cursor: "pointer",
                        }}
                        onClick={() => handleOnClick(event)}
                      ></div>
                    );
                  }
                })}
              </div>
            );
          })}
        </div>
      );
    }
  );

  const dayHoursRef = hours_minutes().map((hourMinutes, key) => {
    return (
      <div key={key} className={"table-cell"}>
        <div className="hourRef-wrapper">
          <p className={"hourRef"}>
            {hourMinutes.minute === 0 ? `${hourMinutes.hour}:00` : ""}
          </p>{" "}
        </div>
      </div>
    );
  });

  return (
    <div className="table">
      <div className={`column`}>{dayHoursRef}</div>
      {dayColumns}
    </div>
  );
};
export default Table;
